(async () => {

  if (!customElements.get('featured-collection-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-featured-collection]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          direction: 'horizontal',
          breakpoints: {
            375: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.FeaturedCollection = FeaturedCollection;

    customElements.define('featured-collection-swiper', FeaturedCollection);

  }

})();
